import { Check } from 'lucide-react';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';

type SuccessStepProps = {
  recipientName: string;
  amount: string;
  reference: string;
  fileName: string;
  onDone: () => void;
};

export const SuccessStep = ({ recipientName, amount, reference, fileName, onDone }: SuccessStepProps) => {
  return (
    <Stack align="stretch" space={16} className="w-full rounded-lg bg-white px-3 pt-8 pb-3 lg:px-8 lg:pt-16 lg:pb-8">
      <Stack space={3} align="center">
        <Inline justify="center" className="h-20 w-20 rounded-full border border-primary bg-white p-4">
          <Check size={30} />
        </Inline>

        <Stack space={2} align="center">
          <p className="text-xl font-medium text-black">The payment has been made!</p>

          <p className="text-base text-muted-foreground">{`Money on the way to ${recipientName}`}</p>
        </Stack>
      </Stack>

      <Stack space={6} align="stretch">
        <Stack space={3} align="stretch">
          <Inline justify="between">
            <p className="text-base font-medium text-muted-foreground">Recipient name</p>

            <p className="text-base font-medium text-black">{recipientName}</p>
          </Inline>

          <Inline justify="between">
            <p className="text-base font-medium text-muted-foreground">Amount</p>

            <p className="text-base font-medium text-black">{amount}</p>
          </Inline>

          {/* Prevents showing empty reference field */}
          {!!reference && (
            <Inline justify="between">
              <p className="text-base font-medium text-muted-foreground">Reference</p>

              <p className="text-base font-medium text-black">{reference}</p>
            </Inline>
          )}

          <Inline justify="between">
            <p className="text-base font-medium text-muted-foreground">Invoice</p>

            <p className="text-base font-medium text-black">{`Invoice ${fileName}`}</p>
          </Inline>
        </Stack>

        <Stack space={3} align="stretch">
          <Button variant="default" onClick={onDone}>
            Done
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
